import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import Select from "react-select";
import { localApi, roundUp, localApiImage } from "utils/imgApi";
import { useHistory } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import Close from "@material-ui/icons/Close";
import Radio from "@material-ui/core/Radio";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Table from "components/Table/Table.js";
import Button from "components/CustomButtons/Button.js";
import { IoLogoWhatsapp } from "react-icons/io";
import { ImMobile } from "react-icons/im";
import { MdEmail } from "react-icons/md";
import { TiPhoneOutline } from "react-icons/ti";
import { TiPhone } from "react-icons/ti";
import SweetAlert from "react-bootstrap-sweetalert";
import styles from "assets/jss/material-dashboard-pro-react/views/viewCartStyle";
import styDrop from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import style from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import logo from "assets/img/apple-admin-icon.png";

import imgMetal from "assets/img/icons8-spring-in-motion-30.png";
import imgMetal1 from "assets/img/icons8-spring-in-motion-30 (1).png";
import imgLabour from "assets/img/icons8-manual-handling-30.png";
import imgLabour1 from "assets/img/icons8-manual-handling-30 (1).png";
import imgPacing from "assets/img/icons8-packing-30.png";
import imgPacing1 from "assets/img/icons8-packing-30 (1).png";

import { credentials } from "utils/imgApi";

const useStyles = makeStyles(styles);
const useStyle = makeStyles(styDrop);
const useStyl = makeStyles(style);

export default function LeadsList() {
  const [adminAddress, setAdminAddress] = React.useState([]);
  const [regAddress1, setRegAddress1] = React.useState([]);
  const [regAddress2, setRegAddress2] = React.useState([]);
  const [client, setClient] = React.useState([]);
  const [getItem, setGetItem] = React.useState([]);
  const [viewCart, setViewCart] = React.useState([]);

  const [allSameGstCash, setAllSameGstCash] = React.useState(false);
  const [clientId, setClientId] = React.useState("");
  const [clientid, setClientid] = React.useState("");
  const [bootselect, setBootSelect] = React.useState("");
  const [reg, setReg] = React.useState("");

  const [cartId, setCartId] = React.useState();
  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [submitteds, setSubmitteds] = React.useState(false);
  const [submittedConfirm, setSubmittedConfirm] = React.useState(false);

  const [newDate, setNewDate] = React.useState("");
  const [termsClient, setTermsClient] = React.useState([]);

  const [selectedCart, setSelectedCart] = React.useState(null);

  const classes = useStyles();
  const classe = useStyle();
  const history = useHistory();
  const classSweet = useStyl();

  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  useEffect(() => {
    const today = new Date();
    today.setDate(today.getDate() + 7); // Add 7 days

    // Format to YYYY-MM-DD
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
    const day = String(today.getDate()).padStart(2, "0");

    setNewDate(`${year}-${month}-${day}`);
  }, []);

  async function getLeadsCart() {
    const api = localApi + `/cart/list/byAdminId/${userObj && userObj.id}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    const r = getResult
      .filter((f) => f.active === true)
      .sort((a, b) => {
        const dateA = a.expireDate ? new Date(a.expireDate).getTime() : 0;
        const dateB = b.expireDate ? new Date(b.expireDate).getTime() : 0;
        return dateB - dateA; // DESC
      });
    const filtered = r.filter((f) => {
      const allIssuesTrue =
        f.metalIssue === true && f.lbrIssue === true && f.pkgIssue === true;

      return !allIssuesTrue;
    });

    const orderApi = `${localApi}/orders/list/byAdminId/${userObj.id}`;
    const orderResult = await fetch(orderApi, {
      method: "GET",
      headers: { Authorization: `Basic ${credentials}` },
    });

    const getOrder = await orderResult.json();

    const finalCart = filtered.map((cart) => {
      const orderIds = getOrder
        .filter((order) => {
          const multiCartIds = Array.isArray(order.multiCartId)
            ? order.multiCartId.map((id) => Number(id))
            : [];

          return (
            Number(order.cartId) === Number(cart.id) ||
            multiCartIds.includes(Number(cart.id))
          );
        })
        .map((order) => order.id);

      return {
        ...cart,
        ordId: orderIds[0] || "",
        ordCartIds: orderIds,
      };
    });

    // console.log(finalCart);

    if (finalCart.length === 0) {
      setSubmitted(true);
      alertMsgOps("Data Not Found");
      // history.push("/admin/dashboard");
    } else {
      setViewCart(finalCart);
    }
  }

  useEffect(() => {
    getLeadsCart();
  }, []);

  const hideAlert = () => {
    setSubmitted(false);
    // window.location.reload(false);
  };

  const hideAlerts = () => {
    setSubmitteds(false);
    setSubmittedConfirm(false);
    // window.location.reload(false);
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      padding: 10,
    }),
    menu: (state) => ({
      color: "#d81b60",
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";

      return { ...provided, opacity, transition };
    },
  };

  var totalCal = 0;
  var totalCalMix = 0;
  var totalSum = 0;

  return (
    <div className={classes.productPage}>
      <GridContainer justify="center" alignItems="center">
        <Card>
          <CardBody>
            {/* <GridContainer
              justify="center"
              alignItems="center"
              className={classes.selects}
            >
              <GridItem xs={12} sm={6} md={4} style={{ marginBottom: "10%" }}>
                <label>Select Company & Client Name</label>
                <Select
                  styles={customStyles}
                  className={classes.select}
                  placeholder="Select Companhy & Client Name..."
                  value={clientId}
                  onChange={handleBoots}
                  options={client.map((c) => {
                    return {
                      label:
                        c && c.company
                          ? c.company + "-" + c.mobile
                          : c.firstname + " " + c.lastname + "-" + c.mobile,
                      value:
                        c && c.company
                          ? c.company + "-" + c.mobile
                          : c.firstname + " " + c.lastname + "-" + c.mobile,
                    };
                  })}
                />
              </GridItem>
            </GridContainer> */}
            {submitted ? (
              <SweetAlert
                type={alertType}
                style={{ display: "block", marginTop: "-100px" }}
                title={alertMsg}
                onConfirm={() => hideAlert()}
                confirmBtnCssClass={
                  classSweet.button + " " + classSweet.success
                }
              />
            ) : null}
            {submitteds ? (
              <SweetAlert
                warning
                style={{ display: "block", marginTop: "100px" }}
                title="Are you sure?"
                // onConfirm={handleConfirm}
                onCancel={() => hideAlerts()}
                confirmBtnCssClass={
                  classSweet.button + " " + classSweet.success
                }
                cancelBtnCssClass={classSweet.button + " " + classSweet.danger}
                confirmBtnText="Yes, delete it!"
                cancelBtnText="Cancel"
                showCancel
              />
            ) : null}

            {submittedConfirm ? (
              <SweetAlert
                success
                style={{ display: "block", marginTop: "100px" }}
                title="Deleted!"
                onConfirm={() => hideAlerts()}
                onCancel={() => hideAlerts()}
                confirmBtnCssClass={
                  classSweet.button + " " + classSweet.success
                }
              >
                Your imaginary file has been deleted.
              </SweetAlert>
            ) : null}

            {/* <div className={classes.borders + " " + classes.container}> */}
            <div className={classes.container}>
              <Table
                tableHead={[
                  <span className={classes.tableHead} key="sr">
                    Sr.
                    {/* <br /> */}
                    No.
                  </span>,
                  "",
                  <span className={classes.tableHead} key="des">
                    Description of Goods
                  </span>,
                  <span
                    className={classes.tableHead + " " + classes.headRight}
                    key="qty"
                  >
                    Making Charge
                  </span>,
                  <span
                    className={classes.tableHead + " " + classes.headRight}
                    key="pri"
                  >
                    Pieces
                  </span>,
                  <span
                    className={classes.tableHead + " " + classes.headRight}
                    key="amt"
                  >
                    Amount
                  </span>,
                  <span className={classes.tableHead + " " + classes.headRight}>
                    Select
                  </span>,
                ]}
                tableData={[
                  ...viewCart.map((c, index) => {
                    const childTotal = c.cartChild
                      .reduce((a, b) => a + b.price, 0)
                      .toFixed(2);

                    const now = new Date();
                    const expiry = new Date(c.expireDate);

                    const diffDays = Math.max(
                      0,
                      Math.ceil((expiry - now) / (1000 * 60 * 60 * 24)),
                    );

                    const dayText = `${diffDays} ${
                      diffDays === 1 ? "day" : "days"
                    }`;

                    const imageUri =
                      c.cartImage?.length > 0
                        ? c.cartImage[0].cpanelPath
                        : null;

                    return [
                      <span className={classes.listNumber} key={c.id}>
                        {index + 1}
                      </span>,
                      <div className={classes.imgContainer} key={c.id}>
                        {/* {"P" + c.pId + "/C" + c.id + "/" + c.cartImage.length} */}
                        <img
                          src={c.cartImage[0].cpanelPath}
                          className={classes.img}
                          style={{ height: "140px" }}
                        />
                      </div>,
                      <span key={c.id}>
                        <h6 className={classes.listDescriptions}>
                          {"D" +
                            c.cartImage[0].imgId +
                            "/P" +
                            c.pId +
                            "/C" +
                            c.id +
                            "/O" +
                            c.ordId}
                          <br />
                          {c.parentTitle} {c.rawTitle} <br />
                          {(c.readyGram * c.setsPcs).toFixed(3)} Avg Gram of{" "}
                          {c.setsDesc} And {c.boxDesc}
                        </h6>
                        <GridContainer
                          className={classes.sizePadding}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "30px", // increase/decrease as needed
                          }}
                        >
                          {c.metalIssue === false ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              <img
                                src={imgMetal1}
                                style={{ width: "30px", height: "30px" }}
                              />
                              <br />
                              Metal Issue
                            </span>
                          ) : (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              <img
                                src={imgMetal}
                                style={{ width: "30px", height: "30px" }}
                              />
                              <br />
                              Metal Issue
                            </span>
                          )}

                          {c.lbrIssue === false ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              <img
                                src={imgLabour}
                                style={{ width: "30px", height: "30px" }}
                              />
                              <br />
                              Labour Issue
                            </span>
                          ) : (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              <img
                                src={imgLabour1}
                                style={{ width: "30px", height: "30px" }}
                              />
                              <br />
                              Labour Issue
                            </span>
                          )}

                          {c.pkgIssue === false ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              <img
                                src={imgPacing1}
                                style={{ width: "30px", height: "30px" }}
                              />
                              <br />
                              Packing Issue
                            </span>
                          ) : (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              <img
                                src={imgPacing}
                                style={{ width: "30px", height: "30px" }}
                              />
                              <br />
                              Packing Issue
                            </span>
                          )}
                        </GridContainer>
                        <GridContainer
                          className={classes.sizePadding}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px", // increase/decrease as needed
                          }}
                        >
                          {c.size1x8 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size1x8 == null
                                ? ""
                                : c.size1x8 == 0
                                ? ""
                                : "1x8"}
                              <br />
                              {c.size1x8 == null
                                ? ""
                                : c.size1x8 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size1x8}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size1x10 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size1x10 == null
                                ? ""
                                : c.size1x10 == 0
                                ? ""
                                : "1x10"}
                              <br />
                              {c.size1x10 == null
                                ? ""
                                : c.size1x10 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size1x10}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size1x12 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size1x12 == null
                                ? ""
                                : c.size1x12 == 0
                                ? ""
                                : "1x12"}
                              <br />
                              {c.size1x12 == null
                                ? ""
                                : c.size1x12 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size1x12}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size1x14 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size1x14 == null
                                ? ""
                                : c.size1x14 == 0
                                ? ""
                                : "1x14"}
                              <br />
                              {c.size1x14 == null
                                ? ""
                                : c.size1x14 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size1x14}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size2x0 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size2x0 == null
                                ? ""
                                : c.size2x0 == 0
                                ? ""
                                : "2x0"}
                              <br />
                              {c.size2x0 == null
                                ? ""
                                : c.size2x0 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size2x0}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size2x2 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size2x2 == null
                                ? ""
                                : c.size2x2 == 0
                                ? ""
                                : "2x2"}
                              <br />
                              {c.size2x2 == null
                                ? ""
                                : c.size2x2 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size2x2}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size2x4 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size2x4 == null
                                ? ""
                                : c.size2x4 == 0
                                ? ""
                                : "2x4"}
                              <br />
                              {c.size2x4 == null
                                ? ""
                                : c.size2x4 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size2x4}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size2x6 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size2x6 == null
                                ? ""
                                : c.size2x6 == 0
                                ? ""
                                : "2x6"}
                              <br />
                              {c.size2x6 == null
                                ? ""
                                : c.size2x6 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size2x6}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size2x8 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size2x8 == null
                                ? ""
                                : c.size2x8 == 0
                                ? ""
                                : "2x8"}
                              <br />
                              {c.size2x8 == null
                                ? ""
                                : c.size2x8 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size2x8}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size2x10 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size2x10 == null
                                ? ""
                                : c.size2x10 == 0
                                ? ""
                                : "2x10"}
                              <br />
                              {c.size2x10 == null
                                ? ""
                                : c.size2x10 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size2x10}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size2x12 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size2x12 == null
                                ? ""
                                : c.size2x12 == 0
                                ? ""
                                : "2x12"}
                              <br />
                              {c.size2x12 == null
                                ? ""
                                : c.size2x12 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size2x12}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size2x14 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size2x14 == null
                                ? ""
                                : c.size2x14 == 0
                                ? ""
                                : "2x14"}
                              <br />
                              {c.size2x14 == null
                                ? ""
                                : c.size2x14 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size2x14}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size3x0 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size3x0 == null
                                ? ""
                                : c.size3x0 == 0
                                ? ""
                                : "3x0"}
                              <br />
                              {c.size3x0 == null
                                ? ""
                                : c.size3x0 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size3x0}
                            </span>
                          ) : (
                            ""
                          )}
                        </GridContainer>
                        <GridContainer
                          className={classes.sizePadding}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px", // increase/decrease as needed
                          }}
                        >
                          {c.size1x9 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size1x9 == null
                                ? ""
                                : c.size1x9 == 0
                                ? ""
                                : "1x9"}
                              <br />
                              {c.size1x9 == null
                                ? ""
                                : c.size1x9 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size1x9}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size1x11 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size1x11 == null
                                ? ""
                                : c.size1x11 == 0
                                ? ""
                                : "1x11"}
                              <br />
                              {c.size1x11 == null
                                ? ""
                                : c.size1x11 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size1x11}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size1x13 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size1x13 == null
                                ? ""
                                : c.size1x13 == 0
                                ? ""
                                : "1x13"}
                              <br />
                              {c.size1x13 == null
                                ? ""
                                : c.size1x13 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size1x13}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size1x15 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size1x15 == null
                                ? ""
                                : c.size1x15 == 0
                                ? ""
                                : "1x15"}
                              <br />
                              {c.size1x15 == null
                                ? ""
                                : c.size1x15 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size1x15}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size2x1 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size2x1 == null
                                ? ""
                                : c.size2x1 == 0
                                ? ""
                                : "2x1"}
                              <br />
                              {c.size2x1 == null
                                ? ""
                                : c.size2x1 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size2x1}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size2x3 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size2x3 == null
                                ? ""
                                : c.size2x3 == 0
                                ? ""
                                : "2x3"}
                              <br />
                              {c.size2x3 == null
                                ? ""
                                : c.size2x3 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size2x3}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size2x5 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size2x5 == null
                                ? ""
                                : c.size2x5 == 0
                                ? ""
                                : "2x5"}
                              <br />
                              {c.size2x5 == null
                                ? ""
                                : c.size2x5 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size2x5}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size2x7 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size2x7 == null
                                ? ""
                                : c.size2x7 == 0
                                ? ""
                                : "2x7"}
                              <br />
                              {c.size2x7 == null
                                ? ""
                                : c.size2x7 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size2x7}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size2x9 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size2x9 == null
                                ? ""
                                : c.size2x9 == 0
                                ? ""
                                : "2x9"}
                              <br />
                              {c.size2x9 == null
                                ? ""
                                : c.size2x9 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size2x9}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size2x11 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size2x11 == null
                                ? ""
                                : c.size2x11 == 0
                                ? ""
                                : "2x11"}
                              <br />
                              {c.size2x11 == null
                                ? ""
                                : c.size2x11 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size2x11}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size2x13 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size2x13 == null
                                ? ""
                                : c.size2x13 == 0
                                ? ""
                                : "2x13"}
                              <br />
                              {c.size2x13 == null
                                ? ""
                                : c.size2x13 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size2x13}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size2x15 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size2x15 == null
                                ? ""
                                : c.size2x15 == 0
                                ? ""
                                : "2x15"}
                              <br />
                              {c.size2x15 == null
                                ? ""
                                : c.size2x15 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size2x15}
                            </span>
                          ) : (
                            ""
                          )}
                          {c.size3x1 != 0 ? (
                            <span
                              className={
                                classes.textCenter +
                                " " +
                                classes.sizeSpan +
                                " " +
                                classes.listDescriptionMM
                              }
                            >
                              {c.size3x1 == null
                                ? ""
                                : c.size3x1 == 0
                                ? ""
                                : "3x1"}
                              <br />
                              {c.size3x1 == null
                                ? ""
                                : c.size3x1 == 0
                                ? ""
                                : c.box * c.setsPcs * c.size3x1}
                            </span>
                          ) : (
                            ""
                          )}
                        </GridContainer>
                        <small
                          style={{
                            float: "right",
                            fontSize: "12px",
                            color: "red",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {dayText}
                        </small>
                        {/* <span className={classes.listDescription}>
                      {c && c.name ? c.name + ", " : ""}{" "}
                      {c && c.mycomment ? c.mycomment : ""}
                    </span> */}
                      </span>,
                      <span
                        className={classes.headRight + " " + classes.listNumber}
                        key={c.id}
                      >
                        {childTotal}/-
                      </span>,
                      <span
                        className={classes.headRight + " " + classes.listNumber}
                        key={c.id}
                      >
                        {c.sizeTotal * c.box * c.setsPcs}
                      </span>,
                      <span
                        className={classes.headRight + " " + classes.listNumber}
                        key={c.id}
                      >
                        ₹{" "}
                        {Math.round(
                          c.sizeTotal * c.box * c.setsPcs * childTotal,
                        )}
                        /-
                      </span>,
                      <Radio
                        checked={selectedCart?.id === c.id}
                        onChange={() => setSelectedCart(c)}
                        value={c.id}
                        sx={{
                          color: "#e91e63",
                          "&.Mui-checked": {
                            color: "#e91e63",
                          },
                        }}
                        className={classes.headRight}
                      />,
                    ];
                  }),
                ]}
              />
              <div className={classes.brand} style={{ textAlign: "center" }}>
                <Button
                  color="rose"
                  disabled={!selectedCart}
                  onClick={() => {
                    history.push({
                      pathname: "/admin/leadsAdd",
                      state: {
                        cart: selectedCart,
                      },
                    });
                  }}
                >
                  Next
                </Button>
              </div>
            </div>
          </CardBody>
        </Card>
      </GridContainer>
    </div>
  );
}
